module.exports = __webpack_public_path__ + "img/center_item.3762260f.png";